import { store } from './store';

export const resetTripFooter = () => {
  store.tripFooter = {
    progress: 0,
    timestamp: undefined,
    setpoint: undefined,
    return: undefined,
  };
};
